import { render, staticRenderFns } from "./BasicEduParents.vue?vue&type=template&id=54e465d9"
import script from "./BasicEduParents.vue?vue&type=script&lang=js"
export * from "./BasicEduParents.vue?vue&type=script&lang=js"
import style0 from "./BasicEduParents.vue?vue&type=style&index=0&id=54e465d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports